import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import './Component_UserDetailsEditor.scss';
import { ModuleFE_User } from '@app/org-frontend';
export class Component_UserDetailsEditor extends ComponentSync {
    // ######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        if (!state.user) {
            const user = ModuleFE_User.cache.unique(nextProps.account._id);
            if (!user)
                return state;
            state.user = new EditableDBItemV3(user, ModuleFE_User);
        }
        return state;
    }
    // ######################### Logic #########################
    submitUserChanges = async () => {
        try {
            await this.state.user?.save();
            this.props.onSubmitCompleted?.();
        }
        catch (err) {
            this.logError(err.message, err);
            this.forceUpdate();
        }
    };
    // ######################### Render #########################
    render() {
        const user = this.state.user;
        if (!user)
            return this.renderNoUser();
        return _jsxs(LL_V_L, { className: 'edit-user-details', children: [_jsx(TS_PropRenderer.Vertical, { label: 'First Name', error: user.hasError('firstName'), children: _jsx(DefaultEditor_InputText_Optional, { editable: user, prop: 'firstName' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Surname', error: user.hasError('surname'), children: _jsx(DefaultEditor_InputText_Optional, { editable: user, prop: 'surname' }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Title', error: user.hasError('title'), children: _jsx(DefaultEditor_InputText_Optional, { editable: user, prop: 'title' }) }), _jsx(Button, { variant: 'primary', onClick: this.submitUserChanges, children: "Submit" })] });
    }
    renderNoUser = () => {
        return _jsx("div", { className: 'edit-user-details__no-user', children: "Could not find user" });
    };
}
